import { BRANDING_GLOBAL, DEFAULT_BRANDING, type Branding } from '../constants';

/**
 * Read deployment branding injected by the server's login-shell route as
 * `window.__FRED_BRANDING__`. Mirrors {@link readAuthCaps}: a pure read
 * of a single synchronous global, no React state, no first-paint flash.
 *
 * The injected `copyright_holder` is `??`'d over the compiled-in
 * {@link DEFAULT_BRANDING} default so a missing/malformed global (dev
 * server, deep-linked SPA) degrades to the canonical brand.
 */
export function readBranding(): Branding {
  if (typeof window === 'undefined') {
    return DEFAULT_BRANDING;
  }
  const raw = (window as unknown as Record<string, unknown>)[BRANDING_GLOBAL];
  if (!raw || typeof raw !== 'object') {
    return DEFAULT_BRANDING;
  }
  const partial = raw as Partial<Record<keyof Branding, unknown>>;
  const copyrightHolder =
    typeof partial.copyright_holder === 'string' && partial.copyright_holder !== ''
      ? partial.copyright_holder
      : DEFAULT_BRANDING.copyright_holder;
  return { copyright_holder: copyrightHolder };
}

export function useBranding(): Branding {
  return readBranding();
}
